module.exports = __webpack_public_path__ + "static/media/textl.55af91ec.png";